import { __exports as storage } from "../../../../../../../_virtual/storage.js";
import { __require as requireCohort } from "../../types/cohort.js";
var hasRequiredStorage;
function requireStorage() {
  if (hasRequiredStorage) return storage;
  hasRequiredStorage = 1;
  Object.defineProperty(storage, "__esModule", { value: true });
  storage.InMemoryCohortStorage = void 0;
  const cohort_1 = requireCohort();
  class InMemoryCohortStorage {
    constructor() {
      this.store = {};
    }
    getAllCohortIds() {
      return new Set(Object.keys(this.store));
    }
    getCohort(cohortId) {
      return cohortId in this.store ? this.store[cohortId] : void 0;
    }
    getCohortsForUser(userId, cohortIds) {
      return this.getCohortsForGroup(cohort_1.USER_GROUP_TYPE, userId, cohortIds);
    }
    getCohortsForGroup(groupType, groupName, cohortIds) {
      var _a, _b;
      const validCohortIds = /* @__PURE__ */ new Set();
      for (const cohortId of cohortIds) {
        if (((_a = this.store[cohortId]) === null || _a === void 0 ? void 0 : _a.groupType) == groupType && ((_b = this.store[cohortId]) === null || _b === void 0 ? void 0 : _b.memberIds.has(groupName))) {
          validCohortIds.add(cohortId);
        }
      }
      return validCohortIds;
    }
    put(cohort) {
      this.store[cohort.cohortId] = cohort;
    }
    delete(cohortId) {
      delete this.store[cohortId];
    }
  }
  storage.InMemoryCohortStorage = InMemoryCohortStorage;
  return storage;
}
export {
  requireStorage as __require
};
//# sourceMappingURL=storage.js.map
